import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import * as moment from 'moment';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { FilterListSingleComponent } from './filter-list-single.component';

const DATE_FORMAT = 'YYYY-MM-DD';

@Component({
  selector: 'filter-date-range',
  templateUrl: './filter-date-range.component.html',
  styleUrls: ['./filter-date-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDateRangeComponent<Name extends string>
  implements OnInit, OnDestroy
{
  constructor(
    private readonly filterListComponent: FilterListSingleComponent<string>,
  ) {}

  @Input()
  allName: Name[];

  readonly selected = this.filterListComponent.selected.pipe(
    map(selected => this.allName.find(n => n == selected) == null),
    distinctUntilChanged(),
  );

  selectedValues = this.filterListComponent.selected.pipe(
    filter(selected => this.allName.find(n => n == selected) == null),
    map(selected => {
      const [from, to] = selected.split(':');
      return { from, to };
    }),
    startWith({
      from: moment().subtract(2, 'w').format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
    }),
  );

  value = new Subject<[Date, Date] | null>();

  select(
    alreadySelected: boolean,
    selectedValues: { to: string; from: string },
  ) {
    if (alreadySelected) {
      return;
    }
    this.filterListComponent.changeSelected(
      `${selectedValues.from}:${selectedValues.to}`,
    );
  }

  sub: Subscription;

  ngOnInit() {
    this.sub = combineLatest([this.value, this.selectedValues]).subscribe(
      ([value, selectedValues]) => {
        let from = selectedValues?.from;
        let to = selectedValues?.to;
        if (value) {
          const [fromDate, toDate] = value;
          from = moment(fromDate).format(DATE_FORMAT);
          to = moment(toDate).format(DATE_FORMAT);
        }
        if (!from || !to) {
          this.filterListComponent.changeSelected('');
          return;
        }
        this.filterListComponent.changeSelected(`${from}:${to}`);
      },
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
